import { render, staticRenderFns } from "./AuditJournal.vue?vue&type=template&id=700b2c06&scoped=true&"
import script from "./AuditJournal.vue?vue&type=script&lang=js&"
export * from "./AuditJournal.vue?vue&type=script&lang=js&"
import style0 from "./AuditJournal.vue?vue&type=style&index=0&id=700b2c06&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700b2c06",
  null
  
)

export default component.exports